import type { LucideIcon } from "lucide-react";

export function SectionHeader({
  Icon,
  title,
}: {
  Icon: LucideIcon;
  title: string;
}) {
  return (
    <div className="flex items-center gap-lg">
      <Icon className="shrink-0 text-fg-quaternary" size={20} />
      <span className="text-lg font-bold text-text-secondary">{title}</span>
    </div>
  );
}
